import { useTranslation } from 'react-i18next';

import { ConnectionsFilterKey } from 'services/repositories/connections/connections';
import { routeToConnectionsPage } from 'support/helpers/navigation/navigation';
import { RelationshipState } from 'support/types/dtos';

import { DashboardCard } from '../components/DashboardCard/DashboardCard';
import { DashboardSection } from '../components/DashboardSection';

type TradePartnerStatsDisplayProps = {
  numberOfReadyPartners: number;
  numberOfTestingPartners: number;
};

export function TradePartnerStatsDisplay({
  numberOfReadyPartners,
  numberOfTestingPartners,
}: TradePartnerStatsDisplayProps) {
  const { t } = useTranslation();

  return (
    <DashboardSection title={t('dashboard:tradePartners.title')}>
      <div className="grid grid-cols-2">
        <DashboardCard
          to={routeToConnectionsPage({ [ConnectionsFilterKey.state]: RelationshipState.READY })}
          title={t('dashboard:tradePartners.active')}
          value={numberOfReadyPartners}
          testId="active-trade-partners"
        />
        <DashboardCard
          title={t('dashboard:tradePartners.inTesting')}
          value={numberOfTestingPartners}
          to={routeToConnectionsPage({ [ConnectionsFilterKey.state]: RelationshipState.IN_TESTING })}
          testId="in-testing-trade-partners"
        />
      </div>
    </DashboardSection>
  );
}
